import React, { FC } from 'react';

export const RequestSuccessManagerIconSvg: FC = () => (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M57.5284 29.1903L50.7584 33.2603L49.4584 31.1003L42.2684 19.1003L41.1484 17.2303L50.5284 11.6003C45.2854 5.72833 37.7789 2.38273 29.9069 2.40934C22.035 2.43626 14.5513 5.83282 9.34842 11.7403L18.8584 17.4603L17.7284 19.3403L10.3384 31.6703L9.24842 33.4903L2.46842 29.4103C2.45844 29.6068 2.45844 29.8037 2.46842 30.0003C2.46842 45.2157 14.803 57.5503 30.0184 57.5503C45.2339 57.5503 57.5684 45.2157 57.5684 30.0003C57.5484 29.7303 57.5484 29.4603 57.5284 29.1903Z"
      fill="#C2E2FF"
    />
    <path
      d="M30.1998 20.8199L31.5398 19.1299L17.7298 19.3799L10.3398 31.6699L18.0898 36.1399L18.8298 35.2099L32.7498 46.8499L46.8598 34.7999L30.1998 20.8199Z"
      fill="#B37149"
    />
    <path
      d="M49.4587 31.0996L42.2688 19.0996L39.8588 20.3096L34.5287 18.6896C33.1474 18.2699 31.6574 18.3988 30.3688 19.0496L23.4688 22.5296C24.9417 25.0499 28.1176 25.9948 30.7288 24.6896L33.2587 23.4096L45.9988 33.9996L49.4587 31.0796V31.0996Z"
      fill="#FFB6AC"
    />
    <path
      d="M25.5717 46.9804L10.7617 35.2004L15.5517 30.6104L30.4617 41.8304L25.5717 46.9804Z"
      fill="#FFB6AC"
    />
    <path
      d="M18.8588 17.5003L17.7287 19.3803L10.3387 31.6703L9.24875 33.4903L2.46875 29.4103C2.58666 22.9013 5.02671 16.6486 9.34875 11.7803L18.8588 17.5003Z"
      fill="white"
    />
    <path
      d="M57.5284 29.1896L50.7584 33.2596L49.4584 31.0996L42.2684 19.0996L41.1484 17.2296L50.5284 11.5996C54.8783 16.4445 57.36 22.6806 57.5284 29.1896Z"
      fill="#28BF9A"
    />
    <path
      d="M26.4209 38.7254L27.1477 39.4123L22.3468 44.4927L21.6199 43.8059L26.4209 38.7254ZM28.7882 37.2299L36.4272 43.5899L35.7873 44.3585L28.1484 37.9984L28.7882 37.2299ZM22.4376 35.7266L23.1635 36.4145L18.4517 41.3866L17.7259 40.6987L22.4376 35.7266ZM31.5525 33.3921L40.125 40.4436L39.4897 41.2158L30.9173 34.1644L31.5525 33.3921ZM18.4705 32.7313L19.1968 33.4186L14.5779 38.2996L13.8516 37.6123L18.4705 32.7313ZM34.2212 29.2725L43.7981 37.3056L43.1555 38.0718L33.5785 30.0386L34.2212 29.2725Z"
      fill="#192C55"
    />
  </svg>
);
